import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPurchasedIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 31,
			height: 31,
			rx: 15.5,
			fill: "#7FE718",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 31,
			height: 31,
			rx: 15.5,
			stroke: "#7FE718"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.4 16.1128L14.0545 19.6L21.6 12.4",
			stroke: "#7FE718",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgPurchasedIcon;
